import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const noticias = [
  {
    id: 1,
    image: "./img/redesneruonales.jpg",
    link: "https://unamglobal.unam.mx/global_revista/investigadores-de-la-unam-ganan-el-google-academic-research-award-2024/"
  },
  {
    id: 2,
    image: "./img/MeridaYu.jpg",
    link: "#"
  },
  {
    id: 3,
    image: "./img/camionruta.jpg",
    link: "#"
  },
  {
    id: 4,
    image: "./img/dt.png",
    link: "#"
  },
  {
    id: 5,
    image: "./img/robot.png",
    link: "#"
  }
];

export const Services = () => {
  const itemsToShow = 4;
  const total = noticias.length;
  const [startIndex, setStartIndex] = useState(0);

  const { t } = useTranslation();

  const handlePrev = () =>
    setStartIndex(prev => (prev - 1 + total) % total);
  const handleNext = () =>
    setStartIndex(prev => (prev + 1) % total);

  const visible = [...noticias, ...noticias].slice(
    startIndex,
    startIndex + itemsToShow
  );

  return (
    <section id="services" className="noticias-section">
      <div className="container">
        <div className="section-title">
          <h2>{t("Blog.titulo")}</h2>
          <p>{t("Blog.subtitulo")}</p>
        </div>
        <div className="carousel-wrapper">
          <button className="arrow prev" onClick={handlePrev}>
            &lt;
          </button>
          <div className="card-container">
            {visible.map((noticia, idx) => (
              <div key={`${noticia.id}-${idx}`} className="news-card">
                <div className="card-header">
                  <h3 className="news-title">
                    {t(`Blog.titulonot${noticia.id}`)}
                  </h3>
                </div>
                <img
                  src={noticia.image}
                  alt={t(`Blog.titulonot${noticia.id}`)}
                  className="news-image"
                />
                <a
                  href={noticia.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="news-button"
                >
                  {t("Blog.botonmas")}
                </a>
              </div>
            ))}
          </div>
          <button className="arrow next" onClick={handleNext}>
            &gt;
          </button>
        </div>
      </div>

      <style>{`
        .noticias-section {
          background-color: #2c2c2c;
          color: #fff;
          padding: 50px 0;
          text-align: center;
        }
        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }
        .section-title h2 {
          font-size: 2.5rem;
          margin-bottom: 20px;
        }
        .section-title p {
          font-size: 2rem;
          margin-bottom: 40px;
        }
        .carousel-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .card-container {
          display: flex;
          gap: 20px;
          overflow: hidden;
        }
        /* --- Tarjetas distribuidas en 4 columnas exactas --- */
        .news-card {
          flex: 0 0 calc((100% - 60px) / 4);
          max-width: calc((100% - 60px) / 4);
          background-color: #000;
          border-radius: 8px;
          overflow: hidden;
          height: 400px;
          display: flex;
          flex-direction: column;
        }
        .card-header {
          padding: 15px;
          background-color: #000;
          color: #fff;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 5px;
        }
        .news-title {
          font-size: 1.8rem;
          margin: 0;
          text-align: center;
          line-height: 1.2;
        }
        .news-image {
          width: 100%;
          height: 260px;
          object-fit: cover;
          margin-bottom: 12px;
        }
        .news-button {
          margin: auto 0 15px;
          padding: 12px 24px;
          font-size: 1.4rem;
          background: linear-gradient(45deg, #ff8a00, #e52e71);
          color: #fff;
          border-radius: 30px;
          text-decoration: none;
          font-weight: bold;
          align-self: center;
        }
        .carousel-wrapper .arrow {
          background: rgba(255,255,255,0.3);
          border: none;
          font-size: 2rem;
          border-radius: 50%;
          width: 50px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
        .carousel-wrapper .prev { left: -25px; }
        .carousel-wrapper .next { right: -25px; }

        /* === Responsive para móvil: 1 tarjeta por vista === */
        @media (max-width: 768px) {
          .news-card {
            flex: 0 0 100% !important;
            max-width: 100% !important;
          }
        }
      `}</style>
    </section>
  );
};

export default Services;
